import { defineMessages } from "react-intl";

const messages = defineMessages({
  streamTitle: {
    id: "containers.Stream.title",
    defaultMessage: "Content Updates"
  },
  welcomeTitle: {
    id: "containers.Stream.welcomeTitle",
    defaultMessage: "Welcome to your feed page!"
  },
  welcomeParagraph: {
    id: "containers.Stream.welcomeParagraph",
    defaultMessage: "Here you can see all of the content you're following on ArchDaily."
  }
});

export default messages;
